const main = () => {
    const header = document.querySelector('.l-header'); // ← 固定ヘッダーのclass
    const headerHeight = header ? header.offsetHeight : 0;

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            // #だけ or 空は無視
            if (href === "#" || href === "" || href === null) return;

            const target = document.querySelector(href);
            if (!target) return;

            e.preventDefault();

            const rect = target.getBoundingClientRect().top;
            const offset = window.pageYOffset + rect - headerHeight;

            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        });
    });

    // Page Topボタンのスクロール方向による表示/非表示
    const pageTopButton = document.querySelector('.l-footer-navigation__button-top');
    if (pageTopButton) {
        let lastScrollY = window.scrollY;
        let ticking = false;

        const updateButtonVisibility = () => {
            const currentScrollY = window.scrollY;
            
            // 上にスクロールしている場合に表示
            if (currentScrollY < lastScrollY && currentScrollY > 100) {
                pageTopButton.classList.add('is-visible');
            } else {
                pageTopButton.classList.remove('is-visible');
            }

            lastScrollY = currentScrollY;
            ticking = false;
        };

        window.addEventListener('scroll', () => {
            if (!ticking) {
                window.requestAnimationFrame(updateButtonVisibility);
                ticking = true;
            }
        });
    }
};

export default main;
